<template>
  <section class="content">
    <history-import-info></history-import-info>
    <button
      style="display:none"
      id="history-info-button"
      data-toggle="modal"
      data-target="#history-import-info">
    </button>
    <button
      style="display:none"
      id="show-key-button"
      data-toggle="modal"
      data-target="#show-key"
    >
    </button>
    <div
      class="modal fade"
      id="add-keypair"
      tabindex="-1"
      role="dialog"
      aria-labelledby="add-keypair"
      style="display: none;"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" id="closeKeyPair" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                ×
              </span>
            </button>
            <h4 class="modal-title" id="forgot_ModalLabel">
              <i class="fa fa-plus mr-5"></i>Key
            </h4>
          </div>
          <div class="modal-body">
            <label>Add new Key-Pair</label>
            <div class="input-group">
              <input class="form-control" placeholder="Issuer..." v-model="issuer">
              <div class="input-group-btn">
                <button
                  @click="newKey()"
                  type="button"
                  class="btn btn-success"
                >
                  <i class="fa fa-save mr-5"></i>{{ 'submit' | translate }}
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
          </div>
        </div>
      </div>
    </div>
    <div
      id="show-key"
      aria-labelledby="show-key"
      class="modal fade"
      role="dialog"
      style="display: none;"
      tabindex="-1"
    >
      <div
        class="modal-dialog"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              id="closeShowKey"
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">
                ×
              </span>
            </button>
            <h4 class="modal-title">
              <i class="fa fa-plus mr-5"></i>Access-Key
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-xs-12">
                <label>Access Key:</label>
                <br/>
                <p style="word-wrap: break-word;">{{ responseKey['access-key'] }}</p>
              </div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-xs-12">
                <label>Secret Key:</label>
                <br/>
                <p style="word-wrap: break-word;">{{ responseKey['secret-key'] }}</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-8">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{ company.name }}</h3>
            <div class="box-tools pull-right">
              <button
                class="btn btn-box-tool"
                data-widget="collapse"
                type="button"
              >
                <i class="fa fa-minus"></i>
              </button>
            </div>
          </div>
          <div class="box-body">
            <div class="row pb-10">
              <div class="col-md-6 col-sm-6">
                <h4 class="page-header">
                  <i class="fa fa-info mr-5"></i>{{ 'configuration' | translate }}
                </h4>
                <ul class="list-group list-group-unbordered">
                  <li class="list-group-item">
                    <b>
                      <a class="pull-left" :href="company.homepage">
                        {{ 'homepage' | translate }}
                      </a>
                    </b>
                    <a class="pull-right" :href="company.homepage">
                      <i class="fa fa-globe mr-5"></i>{{ company.homepage }}
                    </a>
                    <br/>
                  </li>
                  <li class="list-group-item">
                    <b>{{ 'phone_number' | translate }}</b>
                    <a class="pull-right" :href="`tel:${company.telephone}`">
                      <i class="fa fa-phone mr-5"></i>{{ company.telephone }}
                    </a>
                  </li>
                  <li class="list-group-item">
                    <b>{{ 'invoice_email' | translate }}</b>
                    <a class="pull-right">
                      <i class="fa fa-envelope mr-5"></i>{{ company.inv_email }}
                    </a>
                  </li>
                  <li class="list-group-item">
                    <b>{{ 'send_mail_to_branch' | translate }}</b>
                    <div class="btn-group btn-group-xs pull-right">
                      <button
                        :class="['btn btn-success', company.send_mail_to_branch ? 'active' : '']"
                        type="button"
                        @click="toggleActive('comp', company)"
                      >
                        <i class="fa fa-check mr-5"></i>{{ 'yes' | translate }}
                      </button>
                      <button
                        :class="['btn btn-danger', !company.send_mail_to_branch ? 'active' : '']"
                        type="button"
                        @click="toggleActive('comp', company)"
                      >
                        <i class="fa fa-ban mr-5"></i>{{ 'no' | translate }}
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-md-3 col-sm-6 text-right">
                <h4 class="page-header">
                  <i class="fa fa-file-text-o mr-5"></i>{{ 'invoice_address' | translate }}
                </h4>
                <p>
                  {{ company.inv_company }}
                  <br/>
                  {{ company.inv_first_name }}{{ company.inv_last_name }}
                  <br/>
                  {{ company.inv_street }}
                  <br/>
                  {{ company.inv_postcode }} {{ company.inv_city }}
                </p>
                <p>
                  {{ company.default_shipping_country }}
                </p>
              </div>
              <div class="col-md-3 col-sm-6 text-right"></div>
              <div class="col-md-3 col-sm-12 text-right text-center-xs">
                <button
                  aria-expanded="false"
                  class="btn btn-info btn-app"
                  data-target="#editCompany"
                  data-toggle="collapse"
                  type="button"
                >
                  <i class="fa fa-edit"></i> {{ 'edit' | translate }}
                </button>
              </div>
            </div>
            <div class="collapse" id="editCompany">
              <h4 class="page-header"><i class="fa fa-info mr-5"></i> {{ 'basic_information' | translate }}</h4>
              <div class="row">
                <div class="col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label for="homepage">{{ 'homepage' | translate }}:</label>
                    <input
                      id="homepage"
                      v-model="company.homepage"
                      class="form-control"
                      placeholder="homepage"
                      type="text"
                    >
                  </div>
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label for="inv_email">
                      {{ 'invoice_email' | translate }}:
                    </label>
                    <input
                      v-model="company.inv_email"
                      v-validate="'required|email'"
                      :data-vv-as="'invoice_email' | translate"
                      :placeholder="'invoice_email' | translate"
                      class="form-control"
                      name="inv_email"
                      type="text"
                    >
                    <span v-show="errors.has('inv_email')" class="small text-danger">
                      {{ errors.first('inv_email') }}
                    </span>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label for="telephone">{{ 'phone_number' | translate }}:</label>
                    <input type="text" class="form-control" id="telephone" v-model="company.telephone">
                  </div>
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label for="mobile">{{ 'mobile_number' | translate }}:</label>
                    <input type="text" class="form-control" id="mobile" v-model="company.mobile">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-sm-12 pull-left">
                  <div class="form-group">
                    <label>{{ 'parcel_options' | translate }}</label>
                    <select class="form-control" v-model="company.default_parcel_id">
                      <option class="normal" v-bind:key="opt.id" v-for="opt in $store.getters.parcelOptions"
                              :value="opt.id">
                        {{ opt.carrier }} {{ opt.parcel_type }} {{ opt.weight }}KG
                        ({{ opt.length }}x{{ opt.width }}x{{ opt.height }})
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-sm-12 col-xs-12">
                  <h4 class="page-header">
                    <i class="fa fa-list mr-5"></i>Zalando Connected Retail
                  </h4>
                  <div class="row">
                    <div class="col-xs-4">
                      <div class="form-group">
                        <label for="zalando_client_id">Zalando Client ID:</label>
                        <input
                          id="zalando_client_id"
                          v-model="company.connected_retail_client_id"
                          class="form-control"
                          placeholder="Client ID"
                          type="text"
                        >
                      </div>
                    </div>
                    <div class="col-xs-4">
                      <div class="form-group">
                        <label for="Zalando_secret_key">Zalando Secret Key:</label>
                        <input
                          id="Zalando_secret_key"
                          v-model="company.connected_retail_secret_key"
                          class="form-control"
                          placeholder="Secret Key"
                          type="text"
                        >
                      </div>
                    </div>
                    <div class="col-xs-4">
                      <div class="form-group">
                        <br/>
                        <button
                          :disabled="importHistoryButtonDisabled"
                          @click="importHistory()"
                          class="btn btn-info pull-right importHistory"
                        >
                          <i class="fa fa-upload" aria-hidden="true"></i>
                          {{ 'import_history' | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h4 class="page-header">
                    <i class="fa fa-file-text-o mr-5"></i> {{ 'invoice_address' | translate }}
                  </h4>
                  <div class="row">
                    <div class="col-xs-12">
                      <div class="form-group">
                        <label for="company2">{{ 'company_overview' | translate }}:</label>
                        <input
                          class="form-control"
                          id="company2"
                          placeholder="Company"
                          type="text"
                          v-model="company.inv_company"
                        >
                      </div>
                    </div>
                    <div class="col-sm-6 col-xs-12">
                      <div class="form-group">
                        <label for="inv_firstname">{{ 'first_name' | translate }}:</label>
                        <input
                          id="inv_firstname"
                          v-model="company.inv_first_name"
                          class="form-control"
                          type="text"
                        >
                      </div>
                    </div>
                    <div class="col-sm-6 col-xs-12">
                      <div class="form-group">
                        <label for="inv_lastname">{{ 'last_name' | translate }}:</label>
                        <input
                          id="inv_lastname"
                          v-model="company.inv_last_name"
                          class="form-control"
                          type="text"
                        >
                      </div>
                    </div>
                    <div class="col-sm-10 col-xs-12">
                      <div class="form-group">
                        <label for="inv_street">{{ 'street' | translate }}:</label>
                        <input
                          id="inv_street"
                          v-model="company.inv_street"
                          class="form-control"
                          type="text"
                        >
                      </div>
                    </div>
                    <div class="col-sm-4 col-xs-12">
                      <div class="form-group">
                        <label for="inv_postcode">{{ 'zip_code' | translate }}:</label>
                        <input
                          id="inv_postcode"
                          v-model="company.inv_postcode"
                          class="form-control"
                          type="text"
                        >
                      </div>
                    </div>
                    <div class="col-sm-8 col-xs-12">
                      <div class="form-group">
                        <label for="inv_city">{{ 'city' | translate }}:</label>
                        <input
                          id="inv_city"
                          v-model="company.inv_city"
                          class="form-control"
                          type="text"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-xs-6">
                  <button
                    aria-expanded="false"
                    class="btn btn-app btn-danger"
                    data-target="#editCompany"
                    data-toggle="collapse"
                    type="button"
                  >
                    <i class="fa fa-times"></i>Cancel
                  </button>
                </div>
                <div class="col-xs-6 text-right">
                  <button
                    :disabled="errors.any()"
                    class="btn btn-app btn-success"
                    @click="postData"
                  >
                    <i class="fa fa-save"></i>{{ 'save' | translate | capitalize }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-4 pull-right">
        <div class="box box-primary">
          <div class="box-header with-border">
            <i class="fa fa-truck mr-5"></i>
            {{ 'shipping_cost' | translate }}
          </div>
          <div class="box-body">
            <table class="table table-responsive">
              <tbody>
              <tr>
                <td style="border-top:0">
                  {{ 'shipping_price' | translate }}
                </td>
                <td style="border-top:0">
                  {{ company.shipping_price | currency }}
                </td>
              </tr>
              <tr>
                <td>
                  {{ 'shipping_free' | translate }}
                </td>
                <td>
                  {{ company.shipping_free | currency }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <amazon-fees-modal></amazon-fees-modal>
    <br/>
    <div class="row">
      <div class="col-xs-12 col-md-7">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title"><i class="fa fa-key mr-5"></i>{{ 'sales_discounts' | translate }}</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse">
                <i class="fa fa-minus"></i>
              </button>
            </div>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                </div>
              </div>
              <div class="col-xs-12">
                <div class="table-responsive">
                  <template>
                    <hr/>
                    <b-table :fields="fields" :items="this.Cfees">
                      <template v-slot:head(sales_channel)="data">
                        <span>{{ 'sales_channel' | translate }}</span>
                      </template>
                      <template v-slot:head(country)="data">
                        <span>{{ 'country' | translate }}</span>
                      </template>
                      <template v-slot:head(mp_costs_step_1)="data">
                        <span>{{ data.column | translate }}</span>
                      </template>
                      <template v-slot:head(mp_costs_step_2)="data">
                        <span>{{ data.column | translate }}</span>
                      </template>
                      <template v-slot:head(mp_costs_step_3)="data">
                        <span>{{ data.column | translate }}</span>
                      </template>
                      <template v-slot:head(mp_costs_step_4)="data">
                        <span>{{ data.column | translate }}</span>
                      </template>
                      <template v-slot:head(mp_return_costs)="data">
                        <span>{{ 'return_fees' | translate }}</span>
                        <br/>
                        <small class="text-muted">
                          <a class="ml-5" data-toggle="modal" data-target="#amazon-fees-modal">
                            Info <i class="fa fa-info-circle ml-5"></i>
                          </a>
                        </small>
                      </template>
                      <template v-slot:head(mp_payment_costs)="data">
                      <span>
                               {{ 'processing_fee' | translate }} <br/>
                      </span>
                      </template>
                      <template v-slot:head(valid_from)="data">
                        <span>
                          {{ data.column | translate }}
                        </span>
                      </template>
                      <div slot="cell(sales_channel)" slot-scope="data">
                        <span>
                          {{ data.item.sales_channel.name | translate }}
                        </span>
                      </div>
                      <div slot="cell(country)" slot-scope="data">
                        <span>
                          {{ data.item.country }}
                        </span>
                      </div>
                      <div slot="cell(mp_costs_step_1)" slot-scope="data">
                        <span v-if="data.item.type !== 'Zalando'">
                          {{ data.item.mp_costs_step_default | percentage }}
                        </span>
                        <span v-else>
                          {{ data.item.mp_costs_step_1 | percentage }}
                        </span>
                      </div>
                      <div slot="cell(mp_costs_step_2)" slot-scope="data">
                        <span v-if="data.item.type !== 'Zalando'">
                          {{ data.item.mp_costs_step_default | percentage }}
                        </span>
                        <span v-else>
                          {{ data.item.mp_costs_step_2 | percentage }}
                        </span>
                      </div>
                      <div slot="cell(mp_costs_step_3)" slot-scope="data">
                        <span v-if="data.item.type !== 'Zalando'">
                          {{ data.item.mp_costs_step_default | percentage }}
                        </span>
                        <span v-else>
                          {{ data.item.mp_costs_step_3 | percentage }}
                        </span>
                      </div>
                      <div slot="cell(mp_costs_step_4)" slot-scope="data">
                        <span v-if="data.item.type !== 'Zalando'">
                          {{ data.item.mp_costs_step_default | percentage }}
                        </span>
                        <span v-else>
                          {{ data.item.mp_costs_step_4 | percentage }}
                        </span>
                      </div>
                      <div slot="cell(mp_return_costs)" slot-scope="data">
                        <span v-if="data.item.type !== 'Amazon'">
                          {{ data.item.mp_costs_step_default | fieldNotInUse }}
                        </span>
                        <span v-else>
                          {{ data.item.mp_return_costs | percentage }}
                        </span>
                      </div>
                      <div slot="cell(mp_payment_costs)" slot-scope="data">
                        <span v-if="data.item.type !== 'Ebay'">
                          {{ data.item.mp_payment_costs | fieldNotInUse }}
                        </span>
                        <span v-else>
                          {{ data.item.mp_payment_costs | currency }}
                        </span>
                      </div>
                      <div slot="cell(valid_from)" slot-scope="data">
                        <span>{{ data.item.valid_from | orderDateReverse(false) }}</span>
                      </div>
                    </b-table>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12  col-md-5">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title"><i class="fa fa-key mr-5"></i>{{ 'transaction_fees' | translate }}</h3>
            <div class="box-tools pull-right">
              <button
                class="btn btn-box-tool"
                data-widget="collapse"
                type="button"
              >
                <i class="fa fa-minus"></i>
              </button>
            </div>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                </div>
              </div>
              <div class="col-xs-12">
                <div class="table-responsive">
                  <template>
                    <hr/>
                    <b-table :fields="anwrFields" :items="this.Cfees">
                      <template v-slot:head(sales_channel)="data">
                        <span>{{ 'sales_channel' | translate }}</span>
                      </template>
                      <template v-slot:head(country)="data">
                        <span>{{ 'country' | translate }}</span>
                      </template>
                      <template v-slot:head(anwr_trans_costs_step_1)="data">
                        <span>{{ data.column | translate }}</span>
                      </template>
                      <template v-slot:head(anwr_trans_costs_step_2)="data">
                        <span>{{ data.column | translate }}</span>
                      </template>
                      <template v-slot:head(anwr_return_costs_step_1)="data">
                        <span>{{ data.column | translate }}</span>
                      </template>
                      <template v-slot:head(anwr_return_costs_step_2)="data">
                        <span>{{ data.column | translate }}</span>
                      </template>
                      <template v-slot:head(valid_from)="data">
                        <span>{{ data.column | translate }}</span>
                      </template>
                      <div slot="cell(sales_channel)" slot-scope="data">
                        <span>{{ data.item.sales_channel.name | translate }}</span>
                      </div>
                      <div slot="cell(country)" slot-scope="data">
                        <span>{{ data.item.country }}</span>
                      </div>
                      <div slot="cell(anwr_trans_costs_step_1)" slot-scope="data">
                        <span v-if="data.item.type !== 'Tamaris' && data.item.type !== 'Legero'">
                          {{ data.item.anwr_trans_costs_step_1 | currency }}
                        </span>
                        <span v-else>
                          {{ data.item.anwr_trans_costs_step_1 | fieldNotInUse }}
                        </span>
                      </div>
                      <div slot="cell(anwr_trans_costs_step_2)" slot-scope="data">
                        <span v-if="data.item.type !== 'Tamaris' && data.item.type !== 'Legero'">
                          {{ data.item.anwr_trans_costs_step_2 | currency }}
                        </span>
                        <span v-else>
                          {{ data.item.anwr_trans_costs_step_2 | fieldNotInUse }}
                        </span>
                      </div>
                      <div slot="cell(anwr_return_costs_step_1)" slot-scope="data">
                        <span v-if="data.item.type !== 'Tamaris' && data.item.type !== 'Legero'">
                          {{ data.item.anwr_return_costs_step_1 | currency }}
                        </span>
                        <span v-else>
                          {{ data.item.anwr_return_costs_step_1 | fieldNotInUse }}
                        </span>
                      </div>
                      <div slot="cell(anwr_return_costs_step_2)" slot-scope="data">
                        <span v-if="data.item.type !== 'Tamaris' && data.item.type !== 'Legero'">
                          {{ data.item.anwr_return_costs_step_2 | currency }}
                        </span>
                        <span v-else>
                          {{ data.item.anwr_return_costs_step_2 | fieldNotInUse }}
                        </span>
                      </div>
                      <div slot="cell(valid_from)" slot-scope="data">
                        <span v-if="data.item.type !== 'Tamaris' && data.item.type !== 'Legero'">
                          {{ data.item.valid_from | orderDateReverse(false) }}
                        </span>
                        <span v-else>
                          {{ data.item.valid_from | fieldNotInUse }}
                        </span>
                      </div>
                    </b-table>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    <div class="row">-->
    <!--      <div class="col-xs-12">-->
    <!--        <mp-box :company="company"></mp-box>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <i class="fa fa-key mr-5"></i>Token Keys
            </h3>
            <div class="box-tools pull-right">
              <button
                class="btn btn-box-tool"
                data-widget="collapse"
                type="button"
              >
                <i class="fa fa-minus"></i>
              </button>
            </div>
          </div>
          <div class="box-controls">
            <div class="row">
              <div class="col-sm-6 col-xs-12 text-center-xs">
                <button
                  aria-controls="add-note"
                  aria-expanded="false"
                  class="btn btn-info"
                  data-target="#add-keypair"
                  data-toggle="modal"
                  type="button"
                >
                  <i class="fa fa-plus-square mr-5"></i>{{ 'new_token' | translate }}
                </button>
              </div>
            </div>
          </div>
          <div class="box-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>{{ 'issuer' | translate }}</th>
                  <th>Secret-Key</th>
                  <th>{{ 'edit' | translate }}</th>
                  <th>{{ 'delete' | translate }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(key, index) in keys">
                  <td>
                    <template v-if="edit[key.id]">
                      <div class="input-group">
                        <input class="form-control" placeholder="Issuer..." v-model="key.issuer">
                        <div class="input-group-btn">
                          <button
                            class="btn btn-success btn-sm"
                            type="button"
                            @click="updateKey(key)"
                          >
                            <i class="fa fa-save mr-5"></i>{{ 'submit' | translate }}
                          </button>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      {{ key.issuer }}
                    </template>
                  </td>
                  <td>
                    {{ key.secret_key }}
                  </td>
                  <td>
                    <button
                      class="btn btn-info btn-sm"
                      @click="editKey(key.id)"
                    >
                      <i class="fa fa-edit mr-5"></i>{{ 'edit' | translate }}
                    </button>
                  </td>
                  <td>
                    <button
                      class="btn btn-danger btn-sm"
                      disabled
                      @click="deleteKey(key.id)"
                    >
                      <i class="fa fa-trash mr-5"></i>{{ 'delete' | translate }}
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CompanyView',
  data () {
    return {
      Cfees: [],
      selectedKey: {},
      issuer: '',
      company: {},
      edit: [],
      keys: [],
      fees: [],
      countries: [],
      fields: [
        {
          key: 'sales_channel'
        },
        {
          key: 'country'
        },
        {
          key: 'mp_costs_step_1'
        },
        {
          key: 'mp_costs_step_2'
        },
        {
          key: 'mp_costs_step_3'
        },
        {
          key: 'mp_costs_step_4'
        },
        {
          key: 'mp_return_costs'
        },
        {
          key: 'mp_payment_costs'
        },
        {
          key: 'valid_from'
        }
      ],
      anwrFields: [
        {
          key: 'sales_channel'
        },
        {
          key: 'country'
        },
        {
          key: 'anwr_trans_costs_step_1'
        },
        {
          key: 'anwr_trans_costs_step_2'
        },
        {
          key: 'anwr_return_costs_step_1'
        },
        {
          key: 'anwr_return_costs_step_2'
        },
        {
          key: 'valid_from'
        }
      ],
      alerts: [],
      selectedCountry: '',
      selectedFee: '',
      responseKey: {},
      importHistoryButtonDisabled: true,
      shippingCost: {},
      translate: this.$parent.translate
    }
  },
  methods: {
    postData () {
      API.put('/accounting/company', this.company)
        .then(response => {
          let alert = {
            type: 'success',
            dismiss: 4,
            message: 'Successfully edited company'
          }
          this.$store.commit('pushAlert', alert)
          this.$store.commit('updateParcelId', this.company.default_parcel_id)
          this.getCompanyData()
        }, error => {
          if (this.$store.dispatch('checkError', error)) {
            let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
            this.$store.commit('pushAlert', alert)
          } else {
            this.$router.push('/')
          }
        })
    },
    importHistory () {
      API.put('/statistics/connected-retail-import-stats').then(res => {
        if (res) {
          $('#history-info-button').click()
        }
      }).catch(error => {
        console.log(error)
        let alert = {
          type: 'danger',
          dismiss: 15,
          message: 'Something went wrong, try again later!'
        }
        this.$store.commit('pushAlert', alert)
      })
    },
    editKey (keyId) {
      this.edit[keyId] = true
      this.edit = [...this.edit]
    },
    toggleActive (mode = 'key', key) {
      if (mode === 'key') {
        key.is_active = !key.is_active
        this.updateKey(key)
      } else {
        key.send_mail_to_branch = !key.send_mail_to_branch
        this.postData()
      }
    },
    newKey (key = {issuer: this.issuer}) {
      let url = '/accounting/keys'
      API.post(url, key)
        .then(response => {
          $('#closeKeyPair').click()
          this.responseKey = response.data
          this.getKeys()
          $('#show-key-button').click()
        })
        .catch(error => {
          if (error.response.status === 304) {
            $('#closeKeyPair').click()
            let alert = {type: 'warning', dismiss: 4, message: error.response.statusText}
            this.issuer = ''
            this.$store.commit('pushAlert', alert)
          }
        })
    },
    updateKey (key) {
      API.put(`/accounting/keys/${key.id}`, key)
        .then(response => {
          this.getKeys(key.id)
        })
    },
    getKeys (flag) {
      API.get('/accounting/keys')
        .then(response => {
          this.keys = response.data
          if (flag) {
            this.edit[flag] = false
          }
        })
    },
    getFees () {
      API.get('/accounting/company/fees')
        .then(response => {
          for (let key in response.data) {
            this.countries.push(key)
            for (let obj in response.data[key]) {
              let pushdata = response.data[key][obj]
              pushdata.type = pushdata.type[0].toLowerCase() + pushdata.type.substring(1)
              this.Cfees.push(pushdata)
            }
          }
        })
    },
    getCompanyData () {
      if (this.$store.dispatch('checkPermissions', 'co_accounting')) {
        API.get('accounting/company')
          .then(response => {
            this.company = response.data
            this.importHistoryButtonDisabled = !(response.data.connected_retail_client_id != null && response.data.connected_retail_secret_key != null)
            this.getKeys(true)
          })
          .catch(error => {
            if (this.$store.dispatch('checkError', error)) {
              let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
              this.$store.commit('pushAlert', alert)
            } else {
              this.$router.push('/unauthorized')
            }
          })
      } else {
        this.$router.push('/unauthorized')
      }
    }
  },
  computed: {},
  mounted () {
    this.getFees()
    this.$nextTick(() => {
      this.getCompanyData()
    })
  }
}
</script>
<style scoped>
select option.normal {
  margin: 40px;
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, .4)
}

.importHistory {
  margin-top: 5px;
}

select option.normal {
  background: #202227
}
</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/Company.vue